<template>
	<div>

		<!-- Things Search -->
		<v-row>
			<v-col cols="8" sm="6" md="4">

				<v-text-field
						v-model="searchThings"
						append-icon="mdi-magnify"
						class="rounded-lg"
						clearable
						dense
						hide-details
						label="Search"
						outlined
				></v-text-field>

			</v-col>
      <v-col cols="2" sm="6" md="2">
        <div class="form-check form-check-inline">
          <input
              v-model="filters.showDeleted"
              class="form-check-input"
              type="checkbox"
              :value="1"
              false-value=""
          />
          <label class="form-check-label"
          >Archived</label
          >
        </div>
      </v-col>
			<v-col cols="4" sm="12" md="6">
				<div class="align-center d-flex justify-space-between w-100">
					<div></div>
					<div class="d-flex justify-end">
						<v-badge
								:content="filtersCount"
								:value="filtersCount"
								color="secondary"
								overlap
						>
							<v-btn
									class="rounded-lg"
									color="secondary"
									depressed
									outlined
									@click="openFilters"
							>
								Filters
								<v-icon class="ms-2 me-n2">mdi-tune-vertical</v-icon>
							</v-btn>
						</v-badge>

						<v-btn
								v-if="filtersCount"
								class="ms-2 ms-md-4 rounded-lg"
								color="error"
								depressed
								icon
								outlined
								@click="clearFilters('existing')"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>

					</div>
				</div>
			</v-col>
		</v-row>
		<!-- Things Search - END -->

		<bw-table
				aria-label="data-table"
				:custom-search="customFilterFunction()"
				:headers="headers"
				id="list-products"
				:items="filteredThings"
				:itemsPerPage="itemsPerPage"
				hideRowSelect
				hideSearch
				:search="searchThings"
				@current-items="onCurentItemsChange"
		>
			<template v-slot:item.name="{ item: product }">
				<div
					class="text-subtitle-2"
					style="flex-wrap: nowrap !important;"
				>
					{{ product.name }} {{product.deleted ? '(Archived)' : ''}}
				</div>
			</template>
			<template v-slot:item.templateName="{ item: product }">
				<div style="max-width: 160px;">
					{{ helpers.getTemplateName(product.templateName) }}
				</div>
			</template>
			<template v-slot:item.redemption_validation="{ item: product }">
				<div style="max-width: 160px;">
					{{ validationMethods(product) }}
				</div>
			</template>
			<template v-slot:item.venueName="{ item: product }">
				<div style="max-width: 220px;">
					{{ product.venueName }}
				</div>
				<div v-if="product?.overwrittenNames?.length > 0" class="text-subtitle-3 font-italic">
					<div v-for="(overwrittenName) in product.overwrittenNames" :key="`overwritten-name-${overwrittenName}`">
						{{ overwrittenName }}
					</div>
				</div>
			</template>
			<template v-slot:item.created_at="{ item: product }">
				{{
					new Date(product.created_at).toLocaleString("en", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					})
				}}
			</template>
			<template v-slot:item.updated_at="{ item: product }">
				{{
					new Date(product.updated_at).toLocaleString("en", {
						year: "numeric",
						month: "2-digit",
						day: "2-digit"
					})
				}}
			</template>
			<template v-slot:item.actions="{ item: product }">
				<div class="d-flex">
					<v-btn
							color="secondary"
							depressed
							fab
							outlined
							small
							@click="viewProduct(product)"
					>
						<v-icon small>mdi-eye-outline</v-icon>
					</v-btn>
					<v-divider class="mx-2 my-1" vertical></v-divider>
					<v-btn
							color="secondary"
							depressed
							fab
							outlined
							small
							@click="editProduct(product)"
					>
						<v-icon small>mdi-pencil-outline</v-icon>
					</v-btn>
          <v-divider class="mx-2 my-1" vertical></v-divider>
          <v-btn
              v-if="!product.deleted"
              color="error"
              depressed
              fab
              @click="showConfirmRemoveDialog(product)"
              outlined
              small
          >
            <v-icon>
              mdi-trash-can-outline
            </v-icon>
          </v-btn>
          <v-btn
              v-else
              color="secondary"
              depressed
              fab
              @click="showConfirmRecoverDialog(product)"
              outlined
              small
          >
            <v-icon>
              mdi-undo-variant
            </v-icon>
          </v-btn>
				</div>
			</template>
		</bw-table>
    <confirm-dialog
        :description="(itemToUpdate && itemToUpdate.deleted == 1) ? 'Please click \'Confirm\' to archive this item. You will be able to recover this item by filtering by \'Archived\' in the future.' : 'Are your sure?'"
        :open="!!itemToUpdate"
        :title="confirmDialogTitle"
        @cancel="() => itemToUpdate = null"
        @confirm="() => itemToUpdate.deleted == 1 ? doRemove() : doRecover()"
    ></confirm-dialog>
		<bw-modal
				v-if="showFilters"
				:width="400"
				max-width="calc(100dvw - 6rem)"
		>
			<template #body>
				<div>
					<form-title title="Things To Do Filters"/>
					<form-divider inner/>

					<v-row>
						<v-col cols="12">
							<bw-search-select
									v-model="tmpFilters.venues"
									:custom-search="customFilterVenueSearchFunction()"
									hide-details="auto"
									hideSelectAll
									:items="allVenues"
									label="Filter By Venue"
									multiple
							>
								<template v-slot:item-label="{ item }">
									<div>{{item.text}}</div>
									<div v-if="item?.overwrittenNames?.length > 0" class="text-subtitle-3 font-italic">
										<div v-for="(overwrittenName) in item.overwrittenNames" :key="`overwritten-name-${overwrittenName}`">
											{{ overwrittenName }}
										</div>
									</div>
								</template>
							</bw-search-select>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<bw-search-select
									v-model="tmpFilters.types"
									hide-details="auto"
									hideSelectAll
									:items="allTypes"
									label="Filter By Type"
									multiple
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<bw-search-select
									v-model="tmpFilters.passes"
									hide-details="auto"
									hideSelectAll
									:items="allPasses"
									label="Filter By Pass"
									multiple
							/>
						</v-col>
					</v-row>
				</div>
			</template>
			<template #footer>
				<div class="align-center d-flex justify-space-between w-100">
					<div></div>
					<div class="d-flex justify-end">
						<v-btn
								class="me-2 me-md-4 rounded-lg"
								color="grey darken-1"
								depressed
								:large="$vuetify.breakpoint.mdAndUp"
								text
								@click="cancelApplyFilters()"
						>
							Cancel
						</v-btn>
						<v-btn
								class="rounded-lg"
								color="primary"
								depressed
								:large="$vuetify.breakpoint.mdAndUp"
								@click="applyFilters()"
						>
							Show {{ tmpFilteredThings.length }} Results
						</v-btn>
					</div>
				</div>
			</template>
		</bw-modal>
	</div>
</template>

<script>
import { helpers } from '../../../../Shared/helpers';
import {searchHelpers} from "../../../../Shared/searchHelpers";
import ConfirmDialog from "../../../../Shared/UI/ConfirmDialog.vue";

const defaultFilters = {
	passes: [],
	types: [],
	venues: [],
  showDeleted: false,
};

export default {
	name: 'ThingsToDo',
  components: {ConfirmDialog},
	props: {
		productsData: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object | null,
			default: null
		}
	},
	data() {
		return {
			allPasses: [],
			allTypes: [],
			allVenues: [],
            confirmDialogTitle: '',
			filters: { ...defaultFilters },
			filtersSaved: { ...defaultFilters },
			headers: [
				{
					align: 'start',
					mandatory: true,
					text: 'Name',
					value: 'name',
					width: '30%',
				},
				{
					align: 'start',
					selected: true,
					text: 'Type',
					value: 'templateName',
					width: '10%'
				},
				{
					align: 'start',
					selected: true,
					text: 'Validation',
					value: 'redemption_validation',
					width: '10%'
				},
				{
					align: 'start',
					selected: true,
					text: 'Place',
					value: 'venueName',
					width: '10%'
				},
				{
					align: 'start',
					selected: true,
					sortable: true,
					text: 'Created',
					value: 'created_at',
					width: '1%'
				},
				{
					align: 'start',
					selected: true,
					sortable: true,
					text: 'Updated',
					value: 'updated_at',
					width: '1%'
				},
				{
					align: 'start',
					mandatory: true,
					sortable: false,
					text: 'Actions',
					value: 'actions',
					width: '1%',
					filterable: false,
				},
				// we need this hidden column to search by deal ids of the products
				{
					selected: true,
					text: 'Extra Data',
					value: 'extraSearchData'
				}
			],
			helpers,
			itemsPerPage: 10,
			itemsPerPageSaved: 10,
			products: this.productsData,
			searchedProducts: this.productsData,
			searchThings: '',
			showFilters: false,
			tmpFilters: { ...defaultFilters },
      itemToUpdate: null,
		};
	},
	created() {
		this.fillAllPasses();
		this.fillAllTypes();
		this.fillAllVenues();
		this.fillExtraSearchData();
	},
	computed: {
		filteredThings() {
			const { products, filters } = this;

			return this.filterThings(products, filters);
		},

		filtersCount() {
			return Object.values(this.filters)
					.reduce((total, filter) => total + filter.length, 0);
		},

		tmpFilteredThings() {
			const {
				products,
				searchedProducts,
				searchThings,
				tmpFilters
			} = this;

			return this.filterThings(searchThings ? searchedProducts : products, tmpFilters);
		},

	},
	methods: {
		applyFilters() {
			this.itemsPerPage = this.itemsPerPageSaved;
			this.filters = cloneDeep(this.tmpFilters);
			this.showFilters = false;
		},

		cancelApplyFilters() {
			this.itemsPerPage = this.itemsPerPageSaved;
			this.filters = this.filtersSaved;
			this.tmpFilters = cloneDeep(this.filters);
			this.showFilters = false;
		},

		clearFilters() {
			this.filters = { ...defaultFilters };
			this.filtersSaved = this.filters;
			this.cancelApplyFilters();
		},

		customFilterVenueSearchFunction() {
			return searchHelpers.searchByNameAndOverwritten('text');
		},

		customFilterFunction() {
			return searchHelpers.searchFieldsAndAdditionals(this.headers, ['overwrittenNames']);
		},
		
		editProduct(product) {
			window.location.href = `/partner-portal/${this.partner.id}/products/edit-product/${product.id}`
		},

		fillAllPasses() {
			const allPasses = [];

			this.products.map(({ deals }) => {
				deals.forEach(({ id: value, name: text }) => {
					if(allPasses.some(({ value: id }) => id === value)) return;

					allPasses.push({ text, value });
				});
			});

			allPasses.sort(
					({ text: text1 }, { text: text2 }) => {
						// Provide default values for null or undefined
						text1 = text1 || "";
						text2 = text2 || "";

						return text1.localeCompare(text2);
					});

			this.allPasses = allPasses;
		},

		fillAllTypes() {
			const allTypes = [];

			this.products.map(({ templateName: text, template_id: value }) => {
						if(!value || allTypes.some(({ value: id }) => id === value)) return;

						allTypes.push({ text, value });
					}
			);

			allTypes.sort(
					({ text: text1 }, { text: text2 }) => {
						// Provide default values for null or undefined
						text1 = text1 || "";
						text2 = text2 || "";

						return text1.localeCompare(text2);
					});

			this.allTypes = allTypes;
		},

		fillAllVenues() {
			const allVenues = [];
			this.products.forEach(({ venueName: text, venue_id: value, overwrittenNames }) => {
						if(allVenues.some(({ value: id }) => id === value)) return;
						if(value) allVenues.push({ text, value, overwrittenNames });
					}
			);

			allVenues.sort(
					({ text: text1 }, { text: text2 }) => {
						// Provide default values for null or undefined
						text1 = text1 || "";
						text2 = text2 || "";

						return text1.localeCompare(text2);
					});

			this.allVenues = allVenues;
		},

		fillExtraSearchData() {
			// we need this to search by deal ids of the products
			this.products.map(product => {
						product.extraSearchData = product.deal_ids.join(' ');
					}
			)
		},

		filterThings(things, filters) {
			const { passes, types, venues, showDeleted } = filters;

			return things.filter((
							{ deal_ids, template_id: templateId, venue_id: venueId, deleted }
					) => {
						const isPass = !passes.length
								|| deal_ids?.some(id => passes.includes(id));
						const isType = !types.length || types.includes(templateId);
						const isVenue = !venues.length || venues.includes(venueId);
            const isDeleted = showDeleted || !deleted; 

						return isPass && isType && isVenue && isDeleted;
					}
			);
		},

		onCurentItemsChange(currentItems) {
			// we need this to keep tmpFilteredThings.length accurate
			this.searchedProducts = currentItems;
		},

		openFilters() {
			this.itemsPerPageSaved = this.itemsPerPage;
			this.filtersSaved = this.filters;
			if(this.searchThings) {
				// we need this to keep tmpFilteredThings.length accurate
				this.itemsPerPage = -1;
				this.filters = { ...defaultFilters };
			}
			this.showFilters = true;
		},

		

		validationMethods(product) {
			return helpers.camelCaseToWords(product.redemption_validation) +
				(!!product.secondary_redemption_validation ? ' / ' + helpers.camelCaseToWords(product.secondary_redemption_validation) : '');	
		},
		
		viewProduct(product) {
			window.location.href = `/partner-portal/${this.partner.id}/products/view-product/${product.id}`
		},

    doRemove() {
      this.saveChanges('Thing To Do removed.');
    },
    doRecover() {
      this.saveChanges('Thing To Do recovered.');
    },
    async refreshProducts() {
      try {
        const { data } = await axios.get(`/partner-portal/${this.partner.id}/products/get-products?showDeleted=true`);
        this.products = data.data;
        //force update
        this.$forceUpdate();
      }
      catch (error) {
        window.EventBus.$emit('system-messages', [
          { message: error.message, messageType: 'error' }
        ]);
      }
    },
    showConfirmRemoveDialog(item) {
        this.confirmDialogTitle = 'Remove Thing To Do';
        this.itemToUpdate = {id: item.id, deleted: 1};
    },
    showConfirmRecoverDialog(item) {
        this.confirmDialogTitle = 'Recover Thing To Do';
        this.itemToUpdate = {id: item.id, deleted: 0};
    },

    async saveChanges(actionMessage) {
      const product = this.itemToUpdate;
      this.isSaving = true;
      const url = `/partner-portal/${this.partner.id}/products/save-product/${product.id}`;

      try {
        const { data } = await axios.put(url,product);
        this.itemToUpdate = null;
        const message = `${actionMessage} Retrieving things list...`;
        window.EventBus.$emit('system-messages', [
          {
            message,
            messageType: 'success',
            showOverlay: true
          }
        ]);
        await this.refreshProducts();
      }
      catch (error) {
        this.isSaving = false;
        window.EventBus.$emit('system-messages', [
          { message: error.message, messageType: 'error' }
        ]);
      }
    },
	}
};
</script>

<style lang="scss">
#list-products {
	table {
		th:last-child,
		td:last-child {
			display: none !important;
		}
	}
}
</style>
